import React, { useState } from "react";

import { AiOutlinePlus } from "@react-icons/all-files/ai/AiOutlinePlus";
import { MdEmail } from "@react-icons/all-files/md/MdEmail";
import { BsArrowLeft } from "@react-icons/all-files/bs/BsArrowLeft";
import { RiLockPasswordFill } from "@react-icons/all-files/ri/RiLockPasswordFill";

import { useDispatch, useSelector } from "react-redux";
import { signin } from "../../../3- actions/users";
import { unwrapResult } from "@reduxjs/toolkit";
const initialState = { email: "", password: "" };

function Login({ setPopUp, popup, setInterfaces }) {
  const [formData, setFormData] = useState(initialState);
  const [sent, setSent] = useState(false);
  const dispatch = useDispatch();
  const error = useSelector((state) => state.auth.error);

  const [errors, setErrors] = useState("");
  const [success, setSuccess] = useState(false);
  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);

    const email = formData.email;
    const emailRegex = /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/;
    const password = formData.password.length < 3;
    if (!emailRegex.test(email)) {
      setErrors("email address isn't in a proper format");
      setSent(false);
    } else if (password) {
      setErrors("password is required");
      setSent(false);
    } else {
      dispatch(signin(formData))
        .then(unwrapResult)
        .then(() => {
          setErrors("");
          setSuccess(true);
          setSent(false);
        })
        .catch(() => {
          setErrors(error?.error.message);
          setSuccess(false);
          setSent(false);
        });
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  return (
    <div
      className={
        popup
          ? "fixed overflow-y-scroll sm:overflow-visible inset-x-0 inset-y-0 z-[1000] w-full md:w-full lg:w-[75%] xl:w-[60%] 2xl:w-[40%] h-full md:h-fit m-auto bg-tertiary   -translate-y-[0%] opacity-100 duration-500 ease-in-out"
          : "fixed overflow-y-scroll sm:overflow-visible inset-x-0 inset-y-0 z-[1000] w-full md:w-full lg:w-[75%] xl:w-[60%] 2xl:w-[40%] h-full md:h-fit m-auto bg-tertiary   -translate-y-[-200%] opacity-0 duration-500 ease-in-out"
      }
    >
      {/* cancel button */}
      <div
        onClick={() => setPopUp(false)}
        className="group cursor-pointer absolute bg-error/0 md:bg-error hover:bg-error/90 duration-500 ease-out w-[50px] md:w-[70px] h-[50px] md:h-[70px] top-0 right-0 translate-y-[40%] -translate-x-[15px] md:-translate-y-1/2 md:-translate-x-[40%] flex justify-center items-center"
      >
        <AiOutlinePlus className="flex justify-center items-center text-secondary group-hover:text-tertiary duration-500 ease-in-out md:text-tertiary scale-[1.5] md:scale-[2] rotate-45" />
      </div>
      <div className="px-[15px] md:px-20">
        <div className="flex flex-col gap-y-12 py-28 md:py-14">
          <div className="text-secondary">
            <h2 className="font-size">Login</h2>
            <p className="font-SoraR text-[14px] sm:text-[16px] capitalize">
              Enter Your Information To Login
            </p>
          </div>
          {/* form */}
          <div>
            <form onSubmit={handleSubmit}>
              <div className="w-full flex flex-col gap-y-8">
                <div className="flex max-w-full w-full">
                  <div className="h-[52px] w-[52px] bg-primary flex justify-center items-center text-tertiary">
                    <MdEmail className="scale-125" />
                  </div>
                  <input
                    placeholder="Email"
                    className="flex-1 text-[14px] sm:text-[16px] w-full capitalize px-4 h-[52px] outline-none placeholder:text-secondary/50 placeholder:font-SoraR bg-tertiary border-b-2 border-primary"
                    type="email"
                    name="email"
                    maxLength={30}
                    onChange={handleChange}
                  />
                </div>
                <div className="flex items-center w-full">
                  <div className=" h-[52px] max-w-full w-[52px] bg-primary flex justify-center items-center text-tertiary">
                    <RiLockPasswordFill className="scale-125" />
                  </div>
                  <input
                    placeholder="Password"
                    className="flex-1 text-[14px] sm:text-[16px] w-full capitalize px-4 h-[52px] outline-none placeholder:text-secondary/50 placeholder:font-SoraR bg-tertiary border-b-2 border-primary"
                    type="password"
                    name="password"
                    maxLength={30}
                    onChange={handleChange}
                  />
                </div>
                <div className="w-full">
                  <button
                    disabled={sent}
                    className="Purple-btn-effect w-full bg-primary relative h-[52px] text-tertiary font-SoraR"
                  >
                    {sent ? (
                      <div className="flex justify-center items-center scale-75">
                        <div role="status">
                          <svg
                            aria-hidden="true"
                            className="mr-2 w-8 h-8 text-tertiary animate-spin fill-primary"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                              fill="currentColor"
                            ></path>
                            <path
                              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                              fill="currentFill"
                            ></path>
                          </svg>
                        </div>
                        <span className="pl-4">Loading...</span>
                      </div>
                    ) : (
                      <div className="font-SoraR">Login</div>
                    )}
                  </button>
                  {/*success error */}
                  <div
                    className={
                      success
                        ? "opacity-100 text-[14px] sm:text-[16px] duration-500 ease-in-out translate-y-0  bg-green-600   capitalize w-full py-4 flex items-center px-4 md:px-8 text-tertiary md:mt-6 mt-8"
                        : "opacity-0 text-[14px] sm:text-[16px] pointer-events-none h-0 -translate-y-10 duration-500 ease-in-out bg-green-600   capitalize w-full flex items-center px-4 md:px-8 text-tertiary mt-0 "
                    }
                  >
                    <h5>Welcome back!</h5>
                  </div>
                  {/*frontend error */}
                  <div
                    className={
                      errors
                        ? "bg-error text-[14px] sm:text-[16px] capitalize opacity-100 duration-500 ease-in-out translate-y-0  w-full py-4 flex items-center px-4 md:px-8 text-tertiary md:mt-6 mt-8"
                        : "bg-error text-[14px] sm:text-[16px] opacity-0 pointer-events-none -translate-y-10 duration-500 ease-in-out capitalize  w-full h-0 flex items-center px-4 md:px-8 text-tertiary  mt-0"
                    }
                  >
                    <h5>{errors}</h5>
                  </div>
                  {/*backend error */}
                  {!success && (
                    <div
                      className={
                        error
                          ? "bg-error text-[14px] sm:text-[16px] capitalize opacity-100 duration-500 ease-in-out translate-y-0  w-full py-4 flex items-center px-4 md:px-8 text-tertiary md:mt-6 mt-8"
                          : "bg-error text-[14px] sm:text-[16px] opacity-0 -translate-y-10 duration-500 ease-in-out capitalize  w-full h-0 flex items-center px-4 md:px-8 text-tertiary  mt-0"
                      }
                    >
                      <h5>{error?.error.message}</h5>
                    </div>
                  )}
                </div>
              </div>
            </form>
            <div className="mt-8 px-[15px] md:px-0 flex flex-wrap text-center gap-y-2 md:gap-y-0 gap-x-4 justify-center items-center ">
              <h2 className="font-SoraR text-[14px] sm:text-[16px] capitalize">
                Don't have an account?
              </h2>
              <span
                onClick={() => setInterfaces(1)}
                className="text-[14px] sm:text-[16px] cursor-pointer font-SoraS text-primary linebutton relative duration-500 ease-in-out"
              >
                Register
              </span>
            </div>
          </div>

          {/* line */}
          <div className="w-1/3 m-auto h-[1px] bg-secondary/20"></div>
          {/* Don't Have An Account? */}
          <div className=" cursor-pointer px-[15px] md:px-0 flex flex-row-reverse flex-wrap text-center gap-y-2 md:gap-y-0 gap-x-4 justify-center items-center ">
            <h2
              onClick={() => setInterfaces(0)}
              className="text-[14px] sm:text-[16px] font-SoraR capitalize"
            >
              Other social login
            </h2>
            <span className=" scale-150 font-SoraS text-primary">
              <BsArrowLeft />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
